import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button 
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
}

export const SuccessDialog: React.FC<SuccessDialogProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleConfirm = () => {
    onClose();
    navigate('/');
  };

  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose();
        }
      }}
      disableEscapeKeyDown
      aria-labelledby="success-dialog-title"
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 6,
          background: 'linear-gradient(135deg, #f0f5ff 70%, #f8fafc 100%)',
          boxShadow: '0 8px 40px 0 rgba(64, 68, 160, 0.13)',
          backdropFilter: 'blur(20px)',
        }
      }}
    >
      <DialogTitle id="success-dialog-title" sx={{ textAlign: 'center', p: 2, mb: -1 }}>
        <span style={{
          background: 'linear-gradient(90deg, #0ea5e9 0%, #8b5cf6 100%)',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
          fontWeight: 800,
          fontSize: 22
        }}>
          매입 신청 완료
        </span>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', pb: 1 }}>
        <span style={{
          background: 'linear-gradient(90deg, #6366f1 10%, #a21caf 90%)',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
          fontWeight: 700,
          fontSize: 17
        }}>
          매입 신청이 성공적으로 접수되었습니다.
        </span>
        <br />
        <span style={{ color: '#374151', fontWeight: 600 }}>
          카카오 알림톡에서 <span style={{ color: '#0ea5e9', fontWeight: 700 }}>"택배 포장 방법"</span>을 꼭 확인해 주세요!
        </span>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button
          variant="contained"
          onClick={handleConfirm}
          sx={{
            px: 5,
            py: 1.4,
            fontWeight: 700,
            fontSize: 18,
            borderRadius: 99,
            boxShadow: '0 2px 12px 0 rgba(14,165,233,0.08)',
            background: 'linear-gradient(90deg, #0ea5e9 0%, #8b5cf6 100%)',
            transition: 'all 0.18s cubic-bezier(.4,2,.6,1)',
            '&:hover': {
              filter: 'brightness(1.07) saturate(1.1)',
              boxShadow: '0 5px 18px 0 rgba(139,92,246,0.13)',
              background: 'linear-gradient(90deg, #3b82f6 0%, #8b5cf6 100%)',
            }
          }}
          autoFocus
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 